export default "__VITE_ASSET__BHKgshK9__"